import { randomBytes } from './random.js';

const HEX = Array.from({ length: 256 }, (_, byte) => byte.toString(16).padStart(2, '0'));

const UNIX_TS_BYTES = 6;

/**
 * A UUID version 7 — a 48-bit millisecond timestamp followed by randomness, so
 * ids sort by creation time and a primary-key index stays dense. It matches
 * what Postgres 18's `uuidv7()` produces, and exists because `donors` cannot
 * use that default: `root_donor_id` references `donors(id)` and an unmerged
 * donor points at itself, so the id has to be known before the `INSERT` rather
 * than after it — see docs/decisions/0024-donors-dedup-and-merge.md.
 */
export function uuidv7(now: number = Date.now()): string {
  const bytes = randomBytes(16);

  let remaining = now;
  for (let index = UNIX_TS_BYTES - 1; index >= 0; index -= 1) {
    bytes[index] = remaining % 256;
    remaining = Math.floor(remaining / 256);
  }

  bytes[6] = ((bytes[6] as number) & 0x0f) | 0x70;
  bytes[8] = ((bytes[8] as number) & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => HEX[byte] as string).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
